import { Component, input, output } from '@angular/core';
import type { DailyFact } from '../../services/daily-facts.service';
import { DailyFactHeroComponent } from '../daily-fact-hero/daily-fact-hero.component';
import { DailyFactStatusBadgeComponent } from '../daily-fact-status-badge/daily-fact-status-badge.component';
import { DailyFactActionsComponent } from '../daily-fact-actions/daily-fact-actions.component';

@Component({
  selector: 'app-daily-fact-card',
  standalone: true,
  imports: [
    DailyFactHeroComponent,
    DailyFactStatusBadgeComponent,
    DailyFactActionsComponent,
  ],
  templateUrl: './daily-fact-card.component.html',
  styleUrl: './daily-fact-card.component.scss',
})
export class DailyFactCardComponent {
  fact = input.required<DailyFact>();
  getVideoStatusLabel = input.required<(s: string | null | undefined) => string>();
  getVideoStatusClass = input.required<(s: string | null | undefined) => string>();
  canReviewVideo = input.required<(f: DailyFact) => boolean>();
  isGenerating = input.required<(id: string) => boolean>();

  generateVideo = output<DailyFact>();
  reviewVideo = output<DailyFact>();
}
